export default class CommentReplyController {
  static targets = ['form', 'textarea', 'replies', 'toggleText']

  showForm() {
    if (!this.hasFormTarget) return

    this.formTarget.style.display = 'block'
    const textarea = this.textareaTarget
    const prefill = textarea.dataset.prefill || ''

    if (!textarea.value) {
      textarea.value = prefill
    }

    textarea.focus()
    textarea.selectionStart = textarea.value.length
    textarea.selectionEnd = textarea.value.length
  }

  hideForm() {
    if (!this.hasFormTarget) return

    this.formTarget.style.display = 'none'
    this.textareaTarget.value = ''
  }

  toggleReplies() {
    if (!this.hasRepliesTarget) return

    const visible = this.repliesTarget.style.display !== 'none'
    this.repliesTarget.style.display = visible ? 'none' : 'block'

    if (this.hasToggleTextTarget) {
      const currentText = this.toggleTextTarget.textContent
      if (visible) {
        this.toggleTextTarget.textContent = currentText.replace('Ocultar', 'Ver')
      } else {
        this.toggleTextTarget.textContent = currentText.replace(/Ver/, 'Ocultar')
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-controller="comment-reply"]').forEach(el => {
    const controller = new CommentReplyController()

    controller.element = el
    controller.formTarget = el.querySelector('[data-comment-reply-target="form"]')
    controller.textareaTarget = el.querySelector('[data-comment-reply-target="textarea"]')
    controller.repliesTarget = el.querySelector('[data-comment-reply-target="replies"]')
    controller.toggleTextTarget = el.querySelector('[data-comment-reply-target="toggleText"]')

    controller.hasFormTarget = !!controller.formTarget
    controller.hasTextareaTarget = !!controller.textareaTarget
    controller.hasRepliesTarget = !!controller.repliesTarget
    controller.hasToggleTextTarget = !!controller.toggleTextTarget

    el.querySelectorAll('[data-action*="comment-reply#toggleReplies"]').forEach(btn => {
      btn.addEventListener('click', () => controller.toggleReplies())
    })

    el.querySelectorAll('[data-action*="comment-reply#showForm"]').forEach(btn => {
      btn.addEventListener('click', () => controller.showForm())
    })

    el.querySelectorAll('[data-action*="comment-reply#hideForm"]').forEach(btn => {
      btn.addEventListener('click', () => controller.hideForm())
    })
  })
})
